import React, { CSSProperties, FC } from 'react'

import { observer } from 'mobx-react'

import cn from 'classnames'

import { useStore } from 'store'

import { ReactComponent as Ethereum } from 'sources/images/ethereumIcon.svg'
import { ReactComponent as Matic } from 'sources/images/polygonIcon.svg'

import styles from './styles.module.scss'

interface IProps {
  //Change when Anton make
  style?: CSSProperties
  networkType: number | null
  whiteStyle?: boolean
  className?: string
}

//Resize
export const NetworkIcon: FC<IProps> = ({
  networkType,
  style,
  whiteStyle,
  className = '',
}) => {
  if (networkType === null) return null
  return (
    <div
      className={cn({
        [styles.networkIcon]: true,
        [styles.networkIconWhiteStyle]: whiteStyle,
        [className]: !!className,
      })}
      style={style}
    >
      {networkType === 0 ? <Ethereum /> : <Matic />}
    </div>
  )
}

NetworkIcon.displayName = 'NetworkIcon'
